import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiSearch, FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';

const CourtNoticeReport = () => {
    const navigate = useNavigate();
    const [filterType, setFilterType] = useState('all'); // 'all', 'amount'

    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            {/* Header */}
            <div className="bg-[#267c77] text-white p-4 shadow-lg sticky top-0 z-10 flex items-center gap-4">
                <button 
                    onClick={() => navigate(-1)}
                    className="hover:bg-white/20 p-2 rounded-full transition-colors"
                >
                    <FiArrowLeft className="w-6 h-6" />
                </button>
                <h1 className="text-xl font-bold">पाणीपुरवठा कोर्ट नोटीस</h1>
            </div>

            <div className="max-w-7xl mx-auto p-4 md:p-6 mt-4 space-y-4">
                
                {/* Top Filter Section */}
                <div className="bg-white rounded border border-[#267c77]/50 p-4 flex flex-wrap items-center gap-4 md:gap-8 shadow-sm">
                    <div className="bg-[#1e6b66] p-1.5 rounded flex items-center gap-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input 
                                type="radio" 
                                name="filterType" 
                                checked={filterType === 'all'}
                                onChange={() => setFilterType('all')}
                                className="w-4 h-4 text-black focus:ring-black accent-black"
                            />
                            <span className="font-medium text-black text-sm">सर्व</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input 
                                type="radio" 
                                name="filterType" 
                                checked={filterType === 'amount'}
                                onChange={() => setFilterType('amount')}
                                className="w-4 h-4 text-white bg-white focus:ring-white accent-white"
                            />
                            <span className="font-medium text-[#267c77] text-sm">रक्कमेनुसार</span>
                        </label>
                    </div>

                    <div className="flex items-center gap-2 ml-auto md:ml-0">
                        <span className="text-gray-700 font-medium text-sm">पासुन:</span>
                        <input 
                            type="text" 
                            placeholder="रक्कम भरा"
                            className="p-1.5 bg-gray-100 border border-[#267c77]/30 rounded w-28 focus:outline-none text-gray-600 placeholder-gray-400 text-sm"
                        />
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="text-gray-700 font-medium text-sm">पर्यंत :</span>
                        <input 
                            type="text" 
                            placeholder="रक्कम भरा"
                            className="p-1.5 bg-gray-100 border border-[#267c77]/30 rounded w-28 focus:outline-none text-gray-600 placeholder-gray-400 text-sm"
                        />
                    </div>

                    <button className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-6 py-1.5 rounded font-medium shadow-md transition-colors text-sm ml-auto">
                        गणना
                    </button>
                </div>

                {/* Table Section */}
                <div className="bg-white border border-[#267c77]/50 rounded overflow-hidden">
                    {/* Search Bar */}
                    <div className="p-2 border-b border-[#267c77]/30">
                        <div className="flex items-center gap-2">
                             <span className="text-gray-500 text-sm">शोधणे</span>
                        </div>
                    </div>
                   
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-center">
                            <thead className="bg-[#267c77] text-white">
                                <tr>
                                    <th className="p-2 border-r border-[#1e6b66] font-medium">निवडा</th>
                                    <th className="p-2 border-r border-[#1e6b66] font-medium">कनेक्शन नं.</th>
                                    <th className="p-2 border-r border-[#1e6b66] font-medium">मिळकत नं.</th>
                                    <th className="p-2 border-r border-[#1e6b66] font-medium">गालकाचे नाव</th>
                                    <th className="p-2 font-medium">थकित रक्कम</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="border-b border-gray-200">
                                    <td colSpan="5" className="p-2 text-left text-gray-700 bg-white">
                                        No records found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="bg-[#267c77] p-1 flex justify-center items-center gap-1">
                        <button className="p-1 bg-white/20 hover:bg-white/30 rounded text-white disabled:opacity-50">
                            <FiChevronsLeft className="w-4 h-4" />
                        </button>
                        <button className="p-1 bg-white/20 hover:bg-white/30 rounded text-white disabled:opacity-50">
                            <FiChevronLeft className="w-4 h-4" />
                        </button>
                        <button className="px-3 py-0.5 bg-[#1e6b66] text-white rounded text-sm font-medium">
                            1
                        </button>
                        <button className="p-1 bg-white/20 hover:bg-white/30 rounded text-white disabled:opacity-50">
                            <FiChevronRight className="w-4 h-4" />
                        </button>
                        <button className="p-1 bg-white/20 hover:bg-white/30 rounded text-white disabled:opacity-50">
                            <FiChevronsRight className="w-4 h-4" />
                        </button>
                         <select className="ml-2 p-0.5 rounded text-sm text-gray-700 focus:outline-none">
                            <option>10</option>
                            <option>20</option>
                            <option>50</option>
                        </select>
                    </div>
                </div>

                {/* Bottom Form Section */}
                <div className="bg-[#f1f5f9] p-4 md:p-6 rounded border border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-y-4 gap-x-6 items-center">
                        
                        {/* Court Name - Full Width */}
                        <div className="md:col-span-2 text-gray-700 font-medium text-sm md:text-base">
                            कोर्टाचे नाव
                        </div>
                        <div className="md:col-span-10">
                            <input 
                                type="text" 
                                placeholder="कोर्टाचे नाव भरा."
                                className="w-full md:w-1/2 p-2 bg-white border border-[#267c77]/30 rounded focus:border-[#267c77] focus:outline-none placeholder-gray-400 text-sm"
                            />
                        </div>

                        {/* Row 2: War, Date, Time, Report Button */}
                        <div className="md:col-span-1 text-gray-700 font-medium text-sm md:text-base">
                            वार
                        </div>
                        <div className="md:col-span-2">
                             <input 
                                type="text" 
                                placeholder="वार भरा."
                                className="w-full p-2 bg-white border border-[#267c77]/30 rounded focus:border-[#267c77] focus:outline-none placeholder-gray-400 text-sm"
                            />
                        </div>

                        <div className="md:col-span-1 text-gray-700 font-medium text-sm md:text-base text-center">
                            दिनांक
                        </div>
                        <div className="md:col-span-2 relative">
                            <input 
                                type="text" 
                                defaultValue="01/04/2025"
                                className="w-full p-2 bg-white border border-[#267c77]/30 rounded focus:border-[#267c77] focus:outline-none text-gray-700 text-sm"
                            />
                             <FiCalendar className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 w-4 h-4" />
                        </div>

                        <div className="md:col-span-1 text-gray-700 font-medium text-sm md:text-base text-center">
                            वेळ
                        </div>
                        <div className="md:col-span-2">
                             <input 
                                type="text" 
                                placeholder="वेळ भरा."
                                className="w-full p-2 bg-white border border-[#267c77]/30 rounded focus:border-[#267c77] focus:outline-none placeholder-gray-400 text-sm"
                            />
                        </div>

                        <div className="md:col-span-2 flex justify-end">
                            <button className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-6 py-2 rounded font-medium shadow-md transition-colors text-sm w-full md:w-auto">
                                रिपोर्ट
                            </button>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default CourtNoticeReport;
